import { EnderecoSisbi } from './endereco-sisbi';
import { PessoaJuridicaSisbi } from './pessoa-juridica-sisbi';

export class ServicoInspecaoSisbi {
    csServicoInspecao: string;
    csSituacao: string;
    dhInclusao: string;
    enderecos: EnderecoSisbi[];
    idEmail: number;
    idPessoaInclusao: number;
    idServicoInspecao: number;
    idTelefone: number;
    idTipoSituacaoEscopo: number;
    idTipoSuspensaoEscopo: number;
    nmSecretariaVinculada: string;
    nmServico: string;
    organograma: Organograma;
    pessoaJuridica: PessoaJuridicaSisbi;
    stSuspenso: string;
    ufs: string;

    static fromJson(jsonData: any): ServicoInspecaoSisbi {
        const enderecos  = jsonData.enderecos || [];
        jsonData.enderecos = enderecos.map(EnderecoSisbi.fromJson);

        if (jsonData.organograma != null) {
            jsonData.organograma = Organograma.fromJson(jsonData.organograma);
        }
        if (jsonData.pessoaJuridica != null) {
            jsonData.pessoaJuridica = PessoaJuridicaSisbi.fromJson(jsonData.pessoaJuridica);
        }
        return Object.assign(new ServicoInspecaoSisbi(), jsonData);
    }

}

export class Organograma {
    arquivoRaiz: ArquivoRaiz;
    cdHasArquivo: string;
    dhArquivoAnexado: string;
    dhExclusao: string;
    dsArquivo: string;
    idAplicacaoArquivo: number;
    idArquivo: number;
    idPessoa: number;
    idTipoArquivo: number;
    nmFisico: string;
    nmVirtual: string;
    nrTamanho: number;

    static fromJson(jsonData: any): Organograma {
        if (jsonData.arquivoRaiz != null) {
            jsonData.arquivoRaiz = ArquivoRaiz.fromJson(jsonData.arquivoRaiz);
        }
        return Object.assign(new Organograma(), jsonData);
    }
}

export class ArquivoRaiz {
    edArquivoRaiz: string;
    idAplicacaoArquivo: number;
    idArquivoRaiz: number;
    stAtivo: string;

    static fromJson(jsonData: any): ArquivoRaiz {
        return Object.assign(new ArquivoRaiz(), jsonData);
    }
}
